

















































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { Table, TableColumn, Tag, Loading } from 'element-ui';
import md5 from 'js-md5';
import 'element-ui/lib/theme-chalk/table.css';
import 'element-ui/lib/theme-chalk/table-column.css';
import 'element-ui/lib/theme-chalk/tag.css';
import 'element-ui/lib/theme-chalk/loading.css';
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tag);
Vue.use(Loading);

const REQUEST_TIMEOUT = 5000; // 请求超时时间，单位ms
const REQUEST_CYCLE_INTERVAR = 5000; // 循环请求的时间间隔

axios.defaults.timeout = REQUEST_TIMEOUT;

const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '';
const privateKey = (() => {
	if (window.JsObj && typeof window.JsObj.getAppKey === 'function') {
		return window.JsObj.getPriKey();
	}
	return '';
})();
const appKey = (() => {
	if (window.JsObj && typeof window.JsObj.getPriKey === 'function') {
		return window.JsObj.getAppKey();
	}
	return '';
})();
const queryStr = `?app_key=${appKey}&method=Open.getScrollList`;
const setFontSize = (designWidth: number, rem2px: number) => {
	const fontSize = document.body.offsetWidth / designWidth * rem2px;
	document.documentElement.style.fontSize = fontSize + 'px';
};

@Component
export default class App extends Vue {

	private get showList() {
		this.idSeed = (this.idSeed + 1) % 10;
		return this.list.map((item, index) => {
			const id = Math.ceil(100 * this.idSeed + index);
			return {
				id,
				...item,
			};
		});
	}
	private idSeed: number = 0;
	private lastUpdateTime: number = 0;
	private loading: boolean = false;
	private list: Array<Dictionary<any>> = [];
	private getSign(query: string, priKey: string) {
		const str = query + priKey;
		return md5(str).toLocaleLowerCase();
	}
	private async getOfflineShopData() {
		const sign = this.getSign(queryStr.substring(1), privateKey);
		const query = `${encodeURIComponent(queryStr + '&sign=' + sign)}`;
		const url = BASE_URL + '/offlineshop' + `?query=${query}`;
		try {
			this.loading = true;
			const { data: { data, errno, errmsg } } = await axios.get(url);
			if (errno === 0) {
				this.updateList(data);
			} else {
				console.error(errmsg);
			}
		} catch (e) {
			console.error(e);
		}
		this.loading = false;
	}
	// 更新列表
	private updateList(list: Array<Dictionary<any>>) {
		const isSame: boolean = (() => {
			if (list.length !== this.list.length) {
				return false;
			}
			const len = list.length;
			for (let i = 0; i < len; i++) {
				const item1 = list[i];
				const item2 = this.list[i];
				for (const k in item1) {
					if (item1[k] !== item2[k]) {
						return false;
					}
				}
			}
			return true;
		})();
		const now = Math.floor(new Date().getTime() / 1000);
		const duration = now - this.lastUpdateTime;
		if (!isSame || duration > 60) {
			this.list = list;
			this.lastUpdateTime = now;
		}
	}
	private async cycleGetData() {
		if (!appKey || !privateKey) {
			return;
		}
		await this.getOfflineShopData();
		setTimeout(() => {
			this.cycleGetData();
		}, REQUEST_CYCLE_INTERVAR);
	}
	private created() {
		this.cycleGetData();
	}
	private mounted() {
		const designWidth = 750;
		const rem2px = 50;

		setFontSize(designWidth, rem2px);
		// 当屏幕宽度改变时，调用 setFontSize() 方法
		window.onresize = () => {
			setFontSize(designWidth, rem2px);
		};
	}
}
